import {
  ModalCampaignSuccess,
  InfoContainer,
  ContentContainer,
  ButtonsContainer,
  CloseButton
} from './onboardingSuccess.styles';
import { Link } from 'react-router-dom';
export default function ConfirmOnboardingModal({ showModal, onClose, typeOfUser }) {
  return (
    <ModalCampaignSuccess showFinishedModal={showModal}>
      <ContentContainer>
        {typeOfUser === 'investor' ? (
          <h2>
            ¡Haz confirmado tu teléfono correctamente! <br /> Ahora puedes invertir en las campañas
            creadas por las PyMES dentro de <span>FINSPHERA!</span>
          </h2>
        ) : (
          <h2>
            ¡Haz confirmado tu teléfono correctamente! <br /> Ahora puedes seguir con el registro de
            campañas dentro de <span>FINSPHERA!</span>
          </h2>
        )}
        <InfoContainer>
          {typeOfUser === 'investor' ? (
            <h3>
              Recuerda que para comenzar a invertir en campañas, debes ir al apartado de tu
              <Link to="/inversionista/dashboard"> perfil </Link>
              para completar tu información y firmar tus contratos. <br /> ¡Es muy sencillo!
            </h3>
          ) : (
            <h3>
              Recuerda que para crear campañas, debes ir al apartado de tu
              <Link to="/solicitante/dashboard/mi-perfil">perfil</Link>
              para completar tu información y firmar tus contratos. <br /> ¡Es muy sencillo!
            </h3>
          )}
        </InfoContainer>
        <ButtonsContainer>
          <CloseButton onClick={onClose}>Cerrar</CloseButton>
        </ButtonsContainer>
      </ContentContainer>
    </ModalCampaignSuccess>
  );
}
